// Куда положить слой на детали-приёмнике, чтобы рисунок продолжался через шов без разрыва
// на СШИТОМ изделии. Детали в раскладке приставлены смежными краями (линия кроя); на готовом
// изделии их края сшиты, а припуск с обеих сторон уходит внутрь шва. Стыкуем смежные края по
// оси, вдоль которой детали разнесены; по другой оси — сохраняем положение относительно центра.
//   src/dst — bbox { x, y, w, h } (units); gx/gy — глобальный центр слоя-источника (units);
//   allowance — припуск в units (мм × 100). Вход не мутируется.
export function seamContinuationCenter(src, dst, gx, gy, allowance = 0) {
  const sCx = src.x + src.w / 2, sCy = src.y + src.h / 2
  const tCx = dst.x + dst.w / 2, tCy = dst.y + dst.h / 2
  if (Math.abs(tCx - sCx) >= Math.abs(tCy - sCy)) {
    // детали разнесены по горизонтали → шов вертикальный
    const right = tCx > sCx
    const srcSeam = right ? src.x + src.w : src.x   // смежный край источника
    const dstSeam = right ? dst.x : dst.x + dst.w   // смежный край цели
    const cx = gx + (dstSeam - srcSeam) + (right ? 1 : -1) * 2 * allowance
    const cy = tCy + (gy - sCy)
    return { cx, cy }
  }
  // разнесены по вертикали → шов горизонтальный
  const below = tCy > sCy
  const srcSeam = below ? src.y + src.h : src.y
  const dstSeam = below ? dst.y : dst.y + dst.h
  const cy = gy + (dstSeam - srcSeam) + (below ? 1 : -1) * 2 * allowance
  const cx = tCx + (gx - sCx)
  return { cx, cy }
}

// Fallback-раскладка: та же позиция слоя ОТНОСИТЕЛЬНО ЦЕНТРА детали (по обеим осям).
// Стык-по-шву (seamContinuationCenter) предполагает, что смежные края bbox в раскладке —
// физический шов; для деталей, просто разложенных рядом (перёд/спинка), это неверно и слой
// уезжает за деталь. Тогда кладём его в ту же точку детали, что и на источнике — всегда видно.
export function sameRelativeCenter(src, dst, gx, gy) {
  const sCx = src.x + src.w / 2, sCy = src.y + src.h / 2
  const tCx = dst.x + dst.w / 2, tCy = dst.y + dst.h / 2
  return { cx: tCx + (gx - sCx), cy: tCy + (gy - sCy) }
}

// «Переход на другую деталь» через боковой шов (продолжение рисунка, НЕ зеркало и НЕ переворот
// картинки). Перёд и спинка в раскладке разложены встречно, поэтому слой у ПРАВОГО края переда
// продолжается у ЛЕВОГО края спинки: по X берём то же расстояние от бокового края, но с другой
// стороны детали; вертикаль сохраняем. Сама картинка не трогается (герб/лев остаются как есть).
// Припуск сдвигает слой глубже от края-шва к центру, чтобы на сшитом изделии рисунок сходился.
// allowanceU — припуск в units (мм×100).
export function transferToPieceCenter(src, dst, gx, gy, allowanceU = 0) {
  const sCx = src.x + src.w / 2, sCy = src.y + src.h / 2
  const tCx = dst.x + dst.w / 2, tCy = dst.y + dst.h / 2
  const dxFromCenter = gx - sCx                    // + = правее центра источника (ближе к правому краю)
  const cx = tCx - dxFromCenter + Math.sign(dxFromCenter || 1) * 2 * allowanceU
  const cy = tCy + (gy - sCy)
  return { cx, cy }
}

// Стык-по-шву, но с гарантией видимости: если центр стыка ложится ЗА холст детали-приёмника
// (стык неприменим — детали просто разложены рядом, не сшиты этими краями), падаем на
// «та же позиция относительно центра детали». fit = { s, tx, ty, stageW, stageH } приёмника.
export function continuationCenter(src, dst, gx, gy, allowanceU, fit) {
  const seam = seamContinuationCenter(src, dst, gx, gy, allowanceU)
  const px = fit.tx + seam.cx * fit.s
  const py = fit.ty + seam.cy * fit.s
  const onCanvas = px >= 0 && px <= fit.stageW && py >= 0 && py <= fit.stageH
  return onCanvas ? seam : sameRelativeCenter(src, dst, gx, gy)
}
